import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { map, orderBy, sumBy } from "lodash";

import MoedaText from "../ui/inputs/moedaText";
import PercentualText from "../ui/inputs/percentualText";

type Props = {
  data: {
    id: string;
    value: number;
    aux?: any;
  }[];
  quantidade?: boolean;
  idComponent: (id: string) => JSX.Element;
};

export default function TabelaDistribuicao({
  data,
  quantidade = false,
  idComponent,
}: Props) {
  return (
    <TableContainer>
      <Table size="small" padding="normal">
        <TableHead>
          <TableRow>
            <TableCell align="left"></TableCell>
            <TableCell align="right">Saldo</TableCell>
            <TableCell align="right">%</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {map(orderBy(data, "value", "desc"), (d, index) => (
            <TableRow hover sx={{ height: 40 }} key={index}>
              <TableCell>{idComponent(d.id)}</TableCell>
              <TableCell align="right">
                <Typography variant="dataMono" component="div">
                  <MoedaText value={d.value} />
                </Typography>
                {quantidade && (
                  <Typography
                    variant="dataMono"
                    component="div"
                    sx={{ fontSize: 12, color: "text.secondary" }}
                  >
                    {`${d.aux.quantidade} UN.`}
                  </Typography>
                )}
              </TableCell>

              <TableCell align="right">
                <Typography variant="dataMono" component="div">
                  <PercentualText
                    value={d.value / sumBy(data, "value")}
                    decimalScale={2}
                  />
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
